import { rootApiSupplyBeam } from "../../api/rootApi";

export const checkinListAPI = rootApiSupplyBeam.injectEndpoints({
    endpoints: (builder) => ({
        getCheckinListData: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/data/checkinList_admin`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body,
                };
            },
        }),
        getCheckinInfoData: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/data/CheckinInfo`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body,
                };
            },
        }),
        getLocationListData: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/data/getLocationList`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body || {},
                };
            },
        }),
    }),
});

export const { useGetCheckinListDataMutation, useGetCheckinInfoDataMutation, useGetLocationListDataMutation } = checkinListAPI;
